import ExternalMaintenanceForm from '@/components/ExternalMaintenance/ExternalMaintenanceForm'
import ExternalMaintenanceDetail from '@/components/ExternalMaintenance/ExternalMaintenanceDetail'
import ExternalMaintenanceList from "@/components/ExternalMaintenance/ExternalMaintenanceList";

let ExternalMaintenanceRouter = [{
  path: '/external_maintenance',
  name: 'ExternalMaintenanceList',
  component: ExternalMaintenanceList,
  meta: {
    title: 'Contrôles et réparations',
    requiresAuth: true,
    authorizations: ['external-maintenance_index', 'desktop_access']
  }
},
{
  path: '/external_maintenance/:defaultFilterField/:defaultFilterValue',
  name: 'ExternalMaintenanceListByFilter',
  component: ExternalMaintenanceList,
  meta: {
    title: 'Contrôles et réparations',
    requiresAuth: true,
    authorizations: ['external-maintenance_index', 'desktop_access']
  }
},{
  path: '/external_maintenance/new',
  name: 'ExternalMaintenanceNew',
  component: ExternalMaintenanceForm,
  meta: {
    title: 'Nouveau contrôle ou réparation',
    requiresAuth: true,
    authorizations: ['external-maintenance_new', 'desktop_access']
  }
}, {
  path: '/external_maintenance/:id/edit',
  name: 'ExternalMaintenanceEdit',
  component: ExternalMaintenanceForm,
  meta: {
    title: 'Modifier un contrôle ou une réparation',
    requiresAuth: true,
    authorizations: ['external-maintenance_edit', 'desktop_access']
  }
}, {
  path: '/external_maintenance/:id',
  name: 'ExternalMaintenanceDetail',
  component: ExternalMaintenanceDetail,
  meta: {
    title: 'Fiche contrôle ou réparation',
    requiresAuth: true,
    authorizations: ['external-maintenance_show', 'desktop_access']
  }
}]

export default ExternalMaintenanceRouter



// WEBPACK FOOTER //
// ./src/components/ExternalMaintenance/router.js